import $ from "jquery";
import eotwJSXFactory from "base/eotwJSXFactory";
import JSRouter from "adminPage/JSRouter";
import GlobalEvents from "base/GlobalEvents";
import "jquery-serializejson";
import "./focus-within-polyfill";
import values from "object.values";

if (!Object.values) {
    values.shim();
}

window.$ = window.jQuery = $;
window.eotwJSXFactory = eotwJSXFactory;
window.GlobalEvents = GlobalEvents;

JSRouter.register_always(() => {
    $("body").on("click", ".js-toggle-filter", function () {
        if ($(this).is(".admin-filter--active")) {
            $(".admin-filters").stop().slideUp();
        } else {
            $(".admin-filters").stop().slideDown();
        }
        $(this).toggleClass("admin-filter--active");
        return false;
    })
});

if ("string" === typeof window.ADMIN_MODULE) {
    $(() => {
        JSRouter.init();
    });
}
